
import React from 'react'

const MarketplaceInfoPage = () => (
	<text className="text-zinc-400">marketplace</text>
)

export default MarketplaceInfoPage